export default __webpack_public_path__ + "static/media/victory_item1.3569a557.png";